import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

type AlertType = {
  id: number;
  show: boolean;
  variant: string;
  message: string;
}

export default new Vuex.Store({
  state: {
    user:{
    },
    auth: false,
    productName: "",
    alertStack:<AlertType[]>[]
  },
  getters: {
    isAuth(state){
      return state.auth
    },
    notificationStack(state){
      return state.alertStack
    },
    getProductName(state) {
      return state.productName
    }
  },
  mutations: {
    setAuth(state, payload){
      state.auth = payload
    },
    pushNotification(state, payload : AlertType){
      state.alertStack.push(payload)
    },
    removeNotificationByIndex(state, id){
      
      const index=state.alertStack.findIndex(item=>item.id===id)
      
      if (index>-1){
        state.alertStack.splice(index,1)
      }
    },
    setProductName(state, payload) {
      state.productName = payload
    }
  },
  actions: {
    pushNotification(context, payload){
      context.commit('pushNotification', payload)
    },
    removeNotificationById(context, id){
      context.commit('removeNotificationByIndex', id)
    }
  },
  modules: {
  }
})
